import { WebPlugin } from '@capacitor/core';
export class ImageManipulatorWeb extends WebPlugin {
    async getDimensions(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _options) {
        throw new Error('This method is not available on the web platform.');
    }
    async resize(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _options) {
        throw new Error('This method is not available on the web platform.');
    }
}
//# sourceMappingURL=web.js.map